import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';

export const useData = () => {
  const { accountId } = useCurrentAccountId();

  return {
    accountId,
  };
};
